import { render } from "./NotFound.vue?vue&type=template&id=1d39109f&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=1d39109f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d39109f"

export default script